import { connect } from 'react-redux';
import Health, {
  HealthProps,
} from '@/components/DeprecatedPortfolio/components/Health';
import { portfolioSelector } from '@/components/DeprecatedPortfolio/redux/selectors';
import { get } from 'lodash';

type StateProps = Pick<
  HealthProps,
  'debtEquity' | 'portfolioId' | 'lastUpdated'
>;
const mapStateToProps = (state): StateProps => {
  const portfolio = portfolioSelector(state);
  const debtEquity = get(portfolio, ['debtEquity'], undefined);
  const portfolioId = get(portfolio, ['id'], '');
  const lastUpdated = get(portfolio, ['lastUpdatedmilliseconds'], 0);
  return {
    debtEquity,
    portfolioId,
    lastUpdated,
  };
};
export default connect<StateProps, unknown, Partial<HealthProps>>(
  mapStateToProps
)(Health);
